import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.white};
  height: 100vh;
  /* padding: 75px 20px 0 250px; */
  overflow: auto;

  @media only screen and (max-width: 1024px) {
    padding: 50px 10px;
  }
`;
